import React from "react";
import "./Sidebar.scss";
import SC from "../../themes/styledComponents";

export default function Logo() {
  return (
    <SC.LogoSvg
      className="navbar-svg"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="4000.000000pt"
      height="4000.000000pt"
      viewBox="0 0 4000.000000 4000.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <SC.LogoG
        transform="translate(0.000000,4000.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
        className="navbar-svg-g"
      >
        <path
          d="M1353 22773 c2 -15060 3 -15886 20 -16028 72 -620 208 -1161 422
-1680 77 -190 265 -569 365 -740 530 -900 1265 -1635 2165 -2165 171 -100 550
-288 740 -366 584 -240 1210 -385 1865 -434 187 -14 25953 -14 26140 0 655 49
1281 194 1865 434 190 78 569 266 740 366 900 530 1635 1265 2165 2165 100
171 288 550 365 740 214 519 350 1060 422 1680 17 142 18 837 21 13150 2 9481
0 13045 -8 13165 -44 644 -192 1286 -434 1875 -78 190 -266 569 -366 740 -530
900 -1265 1635 -2165 2165 -171 100 -550 288 -740 366 -584 240 -1210 385
-1865 434 -89 7 -5493 10 -15928 10 l-15792 0 3 -15877z m24827 9233 c1160
-88 2045 -305 2845 -695 253 -124 381 -196 585 -329 649 -424 1168 -975 1560
-1657 90 -157 268 -524 339 -701 578 -1443 701 -3358 365 -5724 -56 -400 -77
-521 -754 -4360 -357 -2027 -931 -5282 -1275 -7235 -344 -1952 -628 -3562
-631 -3578 l-6 -27 -3359 0 -3359 0 5 22 c3 13 311 1760 685 3883 375 2123
906 5136 1181 6695 514 2912 563 3200 623 3620 169 1182 179 2074 30 2738 -62
276 -130 474 -239 697 -323 657 -884 1063 -1695 1225 -318 64 -584 84 -990 77
-404 -7 -649 -37 -995 -122 -1044 -256 -1873 -874 -2548 -1900 -270 -412 -545
-963 -752 -1510 -311 -818 -555 -1743 -789 -2985 -36 -190 -540 -3040 -1121
-6335 -580 -3294 -1061 -6016 -1067 -6047 l-11 -58 -3358 0 -3359 0 5 23 c3
12 723 4092 1600 9067 877 4975 1810 10265 2073 11755 l478 2710 3357 3 c1846
1 3357 -1 3357 -5 0 -12 -371 -2118 -375 -2130 -3 -9 10 -13 48 -13 l52 1 73
87 c301 356 727 763 1118 1068 940 733 2065 1257 3274 1528 504 112 1019 186
1510 216 96 6 198 12 225 14 137 10 1105 -4 1295 -18z"
        />
      </SC.LogoG>
    </SC.LogoSvg>
  );
}
